import React from "react";
import styles from "./index.module.scss";
import calendarIcon from "../../assets/images/calenderSvg.svg";
import checkInIcon from "../../assets/images/timerSvg.svg";
import checkOutIcon from "../../assets/images/checkoutSvg.svg";
import investmentIcon from "../../assets/images/inverstmentSvg.svg";

interface ProgramInfoCardV2Props {
  checkinStartTime: string;
  checkinEndTime: string;
  checkoutStartTime?: string;
  checkinDate?: string; // Optional, if needed for display
  checkoutEndDate?: string;
  programFee?: string;
  startsAt?: string; // Optional, if needed for display
  endsAt?: string; // Optional, if needed for display
  gstPercentage?: number; // Optional, if needed for display
}

const ProgramInfoCardV2: React.FC<ProgramInfoCardV2Props> = ({
  checkinStartTime,
  checkinEndTime,
  checkoutStartTime,
  checkinDate,
  checkoutEndDate,
  programFee,
  startsAt,
  endsAt,
  gstPercentage,
}) => {
  // console.log(startsAt, "startsAt in ProgramInfoCardV2");
  return (
    <div className={styles.card_container}>
      {/* <h3 className={styles.card_title}>{title}</h3> */}
      <div className={styles.card_content}>
        <div className={styles.card_item}>
          <img src={calendarIcon} alt="Program Dates" />
          <div className={styles.text_content}>
            <p className={styles.label}>Program Dates</p>
            <p className={styles.value}>{startsAt} to</p>
            <p className={styles.value}>{endsAt}</p>
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.card_item}>
          <img src={checkInIcon} alt="Check-in Time" />
          <div className={styles.text_content}>
            <p className={styles.label}>Check-in Time*</p>
            <p className={styles.value}>
              {checkinStartTime} to {checkinEndTime} on
            </p>
            <p className={styles.value}>{checkinDate}</p>
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.card_item}>
          <img src={checkOutIcon} alt="Check-out Time" />
          <div className={styles.text_content}>
            <p className={styles.label}>Check-out Time*</p>
            <p className={styles.value}>Latest by {checkoutStartTime} on</p>
            <p className={styles.value}>{checkoutEndDate}</p>
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.card_item}>
          <img src={investmentIcon} alt="Investment" />
          <div className={styles.text_content}>
            <p className={styles.label}>Investment</p>
            <p className={styles.value}>INR {programFee} /-</p>
            <p className={styles.value}>(plus GST {gstPercentage}%)</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramInfoCardV2;
